import type { CreateUpdateUserRequest, User } from "./types"
import { api } from "@/api"
import { queryClient } from "@/queryClient"
const { currentUser, retrieveSelf } = useCurrentUser()
export const updateUser = async (
  userId: User["id"],
  params: CreateUpdateUserRequest
) => {
  await api.put(`/users/${userId}/`, { body: params })
  queryClient.invalidateQueries([BASE_USERS_QUERY_KEY])
  if (userId === currentUser.value?.id) {
    retrieveSelf()
  }
}
